module.exports = __webpack_public_path__ + "img/doda.42aac6fb.jpg";